import type { FC } from 'react';
import { Helmet } from "react-helmet-async";
import { PrivacyStyles as styles } from '../css/styles';

const UserAgreement: FC = () => {
    return (
        <>
            <Helmet>
                <title>Пользовательское соглашение — First Klass</title>
                <meta name="description" content="Пользовательское соглашение платформы First Klass (www.first-klass.ru)" />
            </Helmet>
            <div className={styles.privacyContainer}>
                <h1>Пользовательское соглашение</h1>
                <p>
                    Настоящее Пользовательское соглашение (далее — «Соглашение») определяет условия
                    использования интернет-платформы <strong>First Klass</strong>, расположенной по адресу{' '}
                    <strong>www.first-klass.ru</strong> (далее — «Платформа»), и регулирует отношения между
                    Администрацией Платформы и любым лицом, получающим доступ к Платформе или её сервисам
                    (далее — «Пользователь»).
                </p>
                <p>
                    Начиная пользоваться Платформой или завершив процедуру регистрации, Пользователь
                    выражает своё безоговорочное согласие со всеми положениями настоящего Соглашения.
                    Если Пользователь не согласен с каким-либо условием, он должен немедленно
                    прекратить использование Платформы.
                </p>

                <h2>1. Термины и определения</h2>
                <p>
                    В настоящем Соглашении нижеперечисленные термины употребляются в следующем значении:
                </p>
                <p>
                    <strong>1.1. Платформа</strong> — программно-аппаратный комплекс First Klass,
                    доступный по адресу www.first-klass.ru, включая все размещённые на нём сервисы,
                    инструменты и объекты интеллектуальной собственности.
                </p>
                <p>
                    <strong>1.2. Администрация</strong> — владелец и оператор Платформы First Klass,
                    уполномоченный управлять Платформой, определять цели обработки персональных данных
                    и обеспечивать функционирование всех сервисов.
                </p>
                <p>
                    <strong>1.3. Пользователь</strong> — физическое или юридическое лицо, зарегистрированное
                    на Платформе и использующее её сервисы в соответствии с условиями настоящего Соглашения.
                </p>
                <p>
                    <strong>1.4. Учитель</strong> — Пользователь, достигший совершеннолетия, использующий
                    функционал Платформы для создания курсов, проведения занятий и взаимодействия с Учениками.
                </p>
                <p>
                    <strong>1.5. Учебная организация</strong> — юридическое лицо, зарегистрированное в
                    соответствии с законодательством Российской Федерации и использующее Платформу в
                    качестве онлайн-школы для обучения Учеников.
                </p>
                <p>
                    <strong>1.6. Ученик</strong> — Пользователь, получающий образовательные или
                    информационно-консультационные услуги от Учителя или Учебной организации
                    посредством функционала Платформы.
                </p>
                <p>
                    <strong>1.7. Контент</strong> — любые материалы, размещаемые Пользователем на Платформе,
                    включая тексты, изображения, аудио- и видеозаписи, учебные задания и иные файлы.
                </p>
                <p>
                    <strong>1.8. Персональные данные</strong> — сведения, прямо или косвенно относящиеся
                    к определённому физическому лицу, обрабатываемые в соответствии с Федеральным законом
                    № 152-ФЗ «О персональных данных».
                </p>
                <p>
                    <strong>1.9. Учётные данные</strong> — логин и пароль Пользователя, используемые
                    для входа в личный кабинет на Платформе.
                </p>
                <p>
                    <strong>1.10. Сервис</strong> — совокупность функциональных возможностей Платформы,
                    предоставляемых Пользователю на основании настоящего Соглашения.
                </p>
                <p>
                    <strong>1.11. Подписка</strong> — платный доступ к расширенному функционалу Платформы,
                    оформляемый Пользователем на выбранный период.
                </p>

                <h2>2. Общие положения</h2>
                <p>
                    2.1. Настоящее Соглашение является публичной офертой в соответствии со статьёй 437
                    Гражданского кодекса Российской Федерации. Использование Платформы в любой форме
                    признаётся акцептом настоящей оферты согласно статье 438 ГК РФ.
                </p>
                <p>
                    2.2. Соглашение может быть изменено Администрацией без предварительного уведомления.
                    Актуальная редакция Соглашения вступает в силу с момента её публикации на Платформе.
                    Продолжение использования Платформы после внесения изменений означает согласие
                    Пользователя с обновлёнными условиями.
                </p>
                <p>
                    2.3. Пользователю предоставляется личная, неисключительная и непередаваемая лицензия
                    на использование Платформы исключительно в целях, предусмотренных настоящим Соглашением.
                    Пользователь не вправе передавать, сдавать в аренду или иным образом предоставлять
                    третьим лицам права, полученные по настоящей лицензии.
                </p>
                <p>
                    2.4. Функциональные возможности Платформы включают, в том числе:
                </p>
                <ul>
                    <li>Конструктор учебных курсов и уроков</li>
                    <li>Виртуальные классы для проведения занятий</li>
                    <li>Интерактивные задания и тесты с автопроверкой</li>
                    <li>Система управления учениками и группами</li>
                    <li>Инструменты обратной связи и комментирования</li>
                    <li>Планировщик расписания занятий</li>
                    <li>Личный словарь и учебные материалы</li>
                    <li>Мобильное приложение First Klass</li>
                </ul>

                <h2>3. Регистрация на Платформе</h2>
                <p>
                    3.1. Для получения полного доступа к функционалу Платформы необходимо пройти
                    процедуру регистрации: заполнить электронную форму и подтвердить принятие условий
                    настоящего Соглашения.
                </p>
                <p>
                    3.2. При регистрации Пользователь обязуется предоставить достоверные, актуальные
                    и полные сведения о себе. В случае изменения ранее указанных данных Пользователь
                    должен незамедлительно внести соответствующие правки в своём профиле.
                </p>
                <p>
                    3.3. Администрация вправе отказать в регистрации, заблокировать или удалить
                    учётную запись Пользователя без объяснения причин, в том числе при нарушении
                    условий настоящего Соглашения или предоставлении заведомо ложных сведений.
                </p>
                <p>
                    3.4. Регистрируясь на Платформе, Пользователь даёт согласие на получение
                    информационных и сервисных уведомлений. Отказ от рекламных рассылок возможен
                    через настройки личного кабинета или по обращению в службу поддержки.
                </p>

                <h2>4. Авторизация и безопасность учётной записи</h2>
                <p>
                    4.1. Учётные данные Пользователя являются персональными и предназначены
                    исключительно для его личного использования.
                </p>
                <p>
                    4.2. Пользователь несёт полную ответственность за сохранность своих учётных данных
                    и обязуется не передавать их третьим лицам. Все действия, совершённые с
                    использованием учётных данных Пользователя, считаются совершёнными им лично.
                </p>
                <p>
                    4.3. В случае несанкционированного доступа к учётной записи или возникновения
                    подозрений в компрометации пароля Пользователь обязан незамедлительно уведомить
                    Администрацию и самостоятельно изменить пароль.
                </p>
                <p>
                    4.4. Администрация не несёт ответственности за ущерб, возникший вследствие
                    несоблюдения Пользователем требований безопасности в отношении своих учётных данных.
                </p>

                <h2>5. Персональные данные</h2>
                <p>
                    5.1. Администрация обрабатывает персональные данные Пользователя в соответствии
                    с Федеральным законом № 152-ФЗ «О персональных данных» и принимает все необходимые
                    технические и организационные меры для их защиты от несанкционированного доступа,
                    утраты или уничтожения.
                </p>
                <p>
                    5.2. Персональные данные собираются и обрабатываются в следующих целях:
                </p>
                <ul>
                    <li>исполнение настоящего Соглашения и идентификация Пользователя;</li>
                    <li>предоставление персонализированных услуг и доступа к функционалу Платформы;</li>
                    <li>направление сервисных уведомлений, связанных с использованием Платформы;</li>
                    <li>улучшение качества работы Платформы и разработка новых функций;</li>
                    <li>проведение статистических исследований на основе обезличенных данных.</li>
                </ul>
                <p>
                    5.3. Принимая условия настоящего Соглашения, Пользователь выражает добровольное
                    согласие на сбор, хранение, уточнение, использование и иную обработку своих
                    персональных данных Администрацией.
                </p>
                <p>
                    5.4. Пользователь вправе в любой момент запросить изменение или удаление своих
                    персональных данных, направив обращение на адрес электронной почты Администрации
                    или через форму обратной связи на Платформе. Пользователь осознаёт, что удаление
                    данных может повлечь утрату доступа к Платформе.
                </p>
                <p>
                    5.5. Администрация вправе передавать персональные данные Пользователя третьим
                    лицам исключительно в случаях, предусмотренных законодательством Российской
                    Федерации, с согласия Пользователя, либо в рамках передачи бизнеса с переходом
                    обязательств по соблюдению конфиденциальности к приобретателю.
                </p>

                <h2>6. Публикация контента</h2>
                <p>
                    6.1. Размещая Контент на Платформе, Пользователь подтверждает наличие всех
                    необходимых прав на данный Контент и принимает на себя ответственность за его
                    соответствие требованиям законодательства Российской Федерации.
                </p>
                <p>
                    6.2. При использовании Платформы Пользователь обязуется не размещать и не
                    распространять материалы, которые:
                </p>
                <ul>
                    <li>содержат угрозы, оскорбления или дискриминацию по любому признаку;</li>
                    <li>нарушают авторские, смежные или иные права третьих лиц;</li>
                    <li>распространяют вирусы, вредоносные программы или несанкционированный доступ;</li>
                    <li>являются спамом, незаконной рекламой или схемами финансовых пирамид;</li>
                    <li>содержат порнографический или экстремистский контент;</li>
                    <li>нарушают нормы действующего законодательства Российской Федерации.</li>
                </ul>
                <p>
                    6.3. Администрация не несёт ответственности за достоверность и правомерность
                    Контента, размещённого Пользователями, и вправе по собственному усмотрению
                    удалить любой Контент, нарушающий условия настоящего Соглашения.
                </p>
                <p>
                    6.4. Пользователи со статусом «Учитель» или «Учебная организация» самостоятельно
                    обеспечивают защиту персональных данных Учеников, к которым у них имеется доступ,
                    и несут всю ответственность за соблюдение законодательства о персональных данных
                    в отношении своих учебных ресурсов.
                </p>

                <h2>7. Права на интеллектуальную собственность</h2>
                <p>
                    7.1. Все исключительные права на Платформу, её дизайн, программное обеспечение,
                    логотипы, товарные знаки и иные объекты интеллектуальной собственности принадлежат
                    Администрации First Klass или лицензированы ею в установленном порядке.
                </p>
                <p>
                    7.2. Размещая Контент на Платформе, Пользователь предоставляет Администрации
                    неисключительное, безвозмездное и бессрочное право использовать данный Контент
                    в информационных и маркетинговых материалах, связанных с продвижением Платформы,
                    включая воспроизведение, публичный показ и распространение.
                </p>
                <p>
                    7.3. Настоящее Соглашение не передаёт Пользователю никаких прав на фирменное
                    наименование, товарные знаки или доменные имена Администрации.
                </p>

                <h2>8. Оплата и подписка</h2>
                <p>
                    8.1. Доступ к расширенному функционалу Платформы предоставляется на платной
                    основе. Стоимость, условия и порядок оплаты публикуются в разделе «Тарифы»
                    на сайте www.first-klass.ru и являются неотъемлемой частью настоящего Соглашения.
                </p>
                <p>
                    8.2. Подписка действует с момента зачисления оплаты до окончания выбранного
                    периода. Приостановление подписки не предусмотрено.
                </p>
                <p>
                    8.3. Администрация вправе изменять тарифы, уведомив Пользователей путём
                    публикации обновлённой информации в разделе «Тарифы». Изменения не затрагивают
                    действующие оплаченные периоды подписки.
                </p>
                <p>
                    8.4. Расчёты производятся в рублях Российской Федерации. Платформа First Klass
                    поддерживает оплату банковскими картами (VISA, Mastercard, МИР), допускающими
                    проведение интернет-транзакций.
                </p>
                <p>
                    8.5. Оплаченные денежные средства возврату не подлежат, за исключением случаев,
                    прямо предусмотренных действующим законодательством Российской Федерации.
                    До оформления оплаты Пользователь обязан ознакомиться с функционалом
                    Платформы в доступном бесплатном режиме.
                </p>
                <p>
                    8.6. Пользователь несёт самостоятельную ответственность за сохранность данных
                    своей банковской карты. При обнаружении несанкционированных операций Пользователь
                    обязан незамедлительно уведомить Администрацию.
                </p>

                <h2>9. Ответственность сторон</h2>
                <p>
                    9.1. Администрация прилагает все разумные усилия для обеспечения бесперебойной
                    работы Платформы, однако не гарантирует её непрерывной доступности и не несёт
                    ответственности за сбои, вызванные обстоятельствами, находящимися вне её контроля.
                </p>
                <p>
                    9.2. Администрация не несёт ответственности за действия или бездействие Пользователей,
                    а также за содержание Контента, размещённого ими на Платформе.
                </p>
                <p>
                    9.3. Совокупная ответственность Администрации перед Пользователем за прямой ущерб,
                    возникший в результате использования Платформы, ограничена суммой фактически
                    оплаченной Пользователем подписки за последний расчётный период, но не более
                    5 000 (пяти тысяч) рублей. Ответственность наступает исключительно при наличии
                    вины Администрации.
                </p>
                <p>
                    9.4. Пользователь самостоятельно несёт полную ответственность за весь Контент,
                    размещённый им на Платформе, и обязуется возместить Администрации все убытки
                    и расходы, возникшие в связи с претензиями третьих лиц относительно такого Контента.
                </p>

                <h2>10. Форс-мажор</h2>
                <p>
                    10.1. Стороны освобождаются от ответственности за неисполнение обязательств,
                    если таковое явилось следствием обстоятельств непреодолимой силы: стихийных бедствий,
                    эпидемий, техногенных катастроф, военных действий, введения ограничительных мер
                    органами государственной власти, масштабных сбоев телекоммуникационной инфраструктуры
                    и иных событий, предотвратить которые не представляется возможным.
                </p>
                <p>
                    10.2. При наступлении обстоятельств непреодолимой силы срок исполнения обязательств
                    переносится соразмерно продолжительности таких обстоятельств, но не более чем
                    на 60 (шестьдесят) календарных дней. По истечении указанного срока Стороны
                    вправе рассмотреть возможные способы дальнейшего сотрудничества или досрочного
                    прекращения Соглашения.
                </p>

                <h2>11. Запрещённые действия</h2>
                <p>
                    11.1. Без письменного разрешения Администрации Пользователь не вправе использовать
                    Платформу и её Контент в целях, не предусмотренных настоящим Соглашением.
                </p>
                <p>
                    11.2. Пользователю запрещается:
                </p>
                <ul>
                    <li>копировать, воспроизводить или декомпилировать программный код Платформы;</li>
                    <li>применять автоматизированные средства (боты, скраперы) для сбора данных с Платформы;</li>
                    <li>обходить технические средства защиты или создавать чрезмерную нагрузку на серверы;</li>
                    <li>создавать производные продукты на основе Платформы без разрешения Администрации;</li>
                    <li>удалять или изменять знаки правообладателя в любых материалах Платформы;</li>
                    <li>размещать ссылки на Платформу без предварительного согласования с Администрацией;</li>
                    <li>распространять незаконную, запрещённую или вводящую в заблуждение информацию;</li>
                    <li>использовать функционал Платформы для вымогательства или мошеннических действий.</li>
                </ul>

                <h2>12. Заключительные положения</h2>
                <p>
                    12.1. Настоящее Соглашение регулируется и толкуется в соответствии с
                    законодательством Российской Федерации. Все споры, возникающие из отношений,
                    регулируемых настоящим Соглашением, разрешаются в судебном порядке по месту
                    нахождения Администрации, если иное не установлено применимым законодательством.
                </p>
                <p>
                    12.2. До обращения в суд Стороны обязуются предпринять попытку урегулировать
                    спор в досудебном порядке. Претензия направляется в письменной форме на
                    электронный адрес Администрации либо через форму обратной связи на Платформе.
                    Срок рассмотрения претензии составляет 30 (тридцать) календарных дней.
                </p>
                <p>
                    12.3. Если какое-либо положение настоящего Соглашения будет признано
                    недействительным или не имеющим юридической силы, это не затрагивает
                    действительность остальных его положений.
                </p>
                <p>
                    12.4. Настоящее Соглашение составлено на русском языке. В случае расхождений
                    между версиями Соглашения на разных языках приоритет имеет русскоязычная редакция.
                </p>
                <p>
                    12.5. Бездействие Администрации в ответ на нарушения условий настоящего
                    Соглашения не лишает её права предпринять соответствующие меры в любой момент
                    в будущем.
                </p>
                <p>
                    <strong>Редакция от 14 апреля 2026 г.</strong>
                </p>
            </div>
        </>
    );
};

export default UserAgreement;
